import { render, staticRenderFns } from "./add-invoice.vue?vue&type=template&id=020d7acc&scoped=true"
import script from "./add-invoice.vue?vue&type=script&lang=js"
export * from "./add-invoice.vue?vue&type=script&lang=js"
import style0 from "./add-invoice.vue?vue&type=style&index=0&id=020d7acc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d7acc",
  null
  
)

export default component.exports